var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Gerência",
      "maxlength": "40",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla da Gerência",
      "maxlength": "40",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.sigla,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "sigla", $$v);
      },
      expression: "form.filters.sigla"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Secretaria Executiva",
      "items": _vm.form.lists.secretarias,
      "item-text": 'nome',
      "item-value": 'identificador',
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.secretaria,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "secretaria", $$v);
      },
      expression: "form.filters.secretaria"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Setor",
      "maxlength": "40",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.setor,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "setor", $$v);
      },
      expression: "form.filters.setor"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 2,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarOrganograma();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterOrganograma();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    ref: "table",
    staticClass: "mt-5",
    attrs: {
      "item-key": "id",
      "headers": _vm.headers,
      "items": _vm.form.lists.organogramas,
      "footer-props": _vm.$footerProps,
      "items-per-page": 10,
      "show-expand": ""
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: `item.sigla`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.sigla) + " ")];
      }
    }, {
      key: `item.secretariaExecutiva`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.secretariaExecutiva.nome) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref5) {
        var headers = _ref5.headers,
          item = _ref5.item;
        return [_c('td', {
          staticClass: "funcoes",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.setores, function (setor, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "chip-permissao"
          }, [_c('v-icon', {
            staticClass: "funcao",
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-account-multiple")]), _vm._v(" " + _vm._s(setor.nome) + " ")], 1);
        }), 1)], 1)];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Visualizar Organograma',
            "icon": 'mdi-eye-outline',
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarOrganograma(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Editar Organograma',
            "icon": 'mdi-pencil',
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterOrganograma(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Excluir Organograma',
            "icon": 'mdi-delete',
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.excluirOrganograma(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar Organograma' : 'Ativar Organograma'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.ativo ? 'var(--primary-button-color)' : 'silver'}`,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarOrganograma(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Detalhar Organograma',
            "icon": 'mdi-source-fork',
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.detalharOrganograma(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarOrganogramaDialog', {
    attrs: {
      "visible": _vm.dialogManterOrganograma.visible,
      "content": _vm.dialogManterOrganograma.content,
      "edit": _vm.dialogManterOrganograma.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterOrganograma.close();
      },
      "onSave": function ($event) {
        return _vm.buscarOrganograma();
      }
    }
  }), _c('VisualizarOrganogramaDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarOrganograma.visible,
      "content": _vm.dialogVisualizarOrganograma.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarOrganograma.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }